import { fetchAuthSession } from 'aws-amplify/auth';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import * as grower_store from '../store/grower';
import * as user_store from '../store/user';

Vue.use(VueRouter);

const not_found: RouteConfig = {
  path: '*',
  components: { default: () => import('~/views/404.vue') }
};
const base: RouteConfig = {
  path: '/',
  name: 'base',
  meta: { title: "Sign Out", track: false },
  components: { default: () => import('~/views/auth-sign-out.vue') },
  props: { default: route => ({ ...route.query }) }
};
const myfs: RouteConfig = {
  path: '/myfs',
  name: 'myfs',
  components: { default: () => import('~/views/myFS.vue') },
  meta: {
    auth: true,
    title: "myFS Solution Center"
  },
  beforeEnter: (to, __, next) => {
		if (to?.query?.redirect_url) {
      grower_store.useActions(['save_redirect_url']).save_redirect_url(to?.query?.redirect_url?.toString());
    }
		next();
	}
};
const agapps: RouteConfig = {
  path: '/ag-apps',
  name: 'ag-apps',
  components: { default: () => import('~/views/AgApps.vue') },
  meta: {
    auth: true,
    title: "Agronomy Applications Solution Center"
  },
  beforeEnter: (to, __, next) => {
		if (to?.query?.redirect_url) {
      grower_store.useActions(['save_redirect_url']).save_redirect_url(to?.query?.redirect_url?.toString());
    }
		next();
	}
};

const auth_flows: RouteConfig[] = [
  { path: "/sign-in", name: 'sign-in', meta: { title: "Sign In", track: false }, components: { default: () => import('~/views/auth-sign-in.vue') }, props: { default: route => ({ ...route.query }) } },
  { path: "/sign-up", name: 'sign-up', meta: { title: "Sign Up", track: false  }, components: { default: () => import('~/views/auth-sign-up.vue') }, props: { default: route => ({ ...route.query }) } },
  { path: "/verify-email", name: 'verify-email', meta: { title: "Verify Email", track: false }, components: { default: () => import('~/views/auth-verify-email.vue') }, props: { default: route => ({ ...route.query, must_register: route.query.must_register ? (Array.isArray(route.query.must_register) ? route.query.must_register[0] : route.query.must_register).toLowerCase() === 'true' : false }) } },
  { path: "/forgot-password", name: 'forgot-password', meta: { title: "Forgot Password", track: false }, components: { default: () => import('~/views/auth-forgot-password.vue') }, props: { default: route => ({ ...route.query }) } },
  { path: "/reset-password", name: 'reset-password', meta: { title: "Reset Password", track: false }, components: { default: () => import('~/views/auth-reset-password.vue') }, props: { default: route => ({ ...route.query }) } },
  { path: "/force-change-password", name: 'force-change-password', meta: { title: "Force Change Password" }, components: { default: () => import('~/views/auth-force-change-password.vue') }, props: { default: route => ({ ...route.query }) } },
];

const routes = [
  /* other routes go here */
  base, myfs, agapps, ...auth_flows, not_found,
];

const router = new VueRouter({ mode: 'history', base: '/', routes });

router.beforeEach(async (to, _, next) => {
  try {
    const { email, must_change_password, must_verify_email } = user_store.useState(['email', 'must_change_password', 'must_verify_email']);
    console.log('must_change_password', must_change_password.value, 'must_verify_email', must_verify_email.value);

    if (must_change_password.value && to.name !== 'force-change-password') return next({ name: 'force-change-password' });
    if (!must_change_password.value && to.name === 'force-change-password') return next({ name: 'sign-in' });
    if (must_verify_email.value && to.name !== 'verify-email') return next({ name: 'verify-email' });
    if (!(must_verify_email.value || (to.query.code && to.query.username)) && to.name === 'verify-email') return next({ name: 'sign-in' });
    if (!email.value && to.name === 'reset-password') return next({ name: 'sign-in' });

  } catch (err) {
    if (to.name !== 'sign-in') return next({ name: 'sign-in' });
  }

  next()
});

export default router
